import React, {  useEffect } from "react";
import HookFormContratantData from "../Components/hookFormContratantData";
import { getConfigProduct } from "../Store/secureInvestmentIncome/actions";
import { useDispatch } from "react-redux";
import { validateAdviserRegister } from "../Store/adviser/actions";
import { useSelector } from "react-redux";
import ModalRegisterAdviser from "../Components/modalRegisterAdviser";
import Loading from "../Components/loading";
import { ToastContainer } from "react-toastify";


const ContratantData = () => {

  const callApi = useSelector((state) => state.adviser.callApi);
  const loading = useSelector((state) => state.adviser.loading);
  const error_permit = useSelector((state) => state.adviser.error_permit);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfigProduct());
    if (callApi) validateAdviserRegister(dispatch);
  }, []);

  return (
    <div className="secureInvestmentIncome">
      <HookFormContratantData   /> 
      <ModalRegisterAdviser open={error_permit} login={true} />
      <ToastContainer containerId={"A"} />

      {loading && <Loading />}
    </div>
  );
};

export default ContratantData;
